<template>
    <div
        v-cloak
        :class="{scrolled: $store.state.isScrolled, large: large, small: !large}"
        class="logo-container"
    >
        <a
            v-if="!isExperienceEditor"
            :href="url(options.LogoLink)"
        >
            <img
                v-if="large && !isScrolled && options.LogoFullscreenLargeImage"
                :src="options.LogoFullscreenLargeImage.Url"
                :alt="options.LogoFullscreenLargeImage.Alt"
                :class="nonScroll"
                rel="preload"
                class="h-100 logo show-image"
            >
            <img
                v-if="large && isScrolled && options.LogoFullscreenOnScrollImage"
                :src="options.LogoFullscreenOnScrollImage.Url"
                :alt="options.LogoFullscreenOnScrollImage.Alt"
                :class="nonScroll"
                rel="preload"
                class="h-100 logo show-image"
            >
            <img
                v-if="!large && options.LogoMobileImage"
                :src="options.LogoMobileImage.Url"
                :alt="options.LogoMobileImage.Alt"
                :class="nonScroll"
                rel="preload"
                class="h-100 logo show-image"
            >
        </a>
        <div
            v-else
            class="h-100"
        >
            <div class="ee h-100">
                <div
                    v-if="large && !isScrolled"
                    class="ee"
                    v-html="options.LogoFullscreenLargeImage.EditorField"
                />
                <div
                    v-else-if="large && isScrolled"
                    class="ee"
                    v-html="options.LogoFullscreenOnScrollImage.EditorField"
                />
                <div
                    v-else
                    class="ee"
                    v-html="options.LogoMobileImage.EditorField"
                />
            </div>
        </div>
    </div>
</template>
<script>
import HeaderBaseMixinVue from './HeaderBaseMixin.vue';

export default {
    name: 'LogoHeader',
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            scroll: '',
            nonScroll: ''
        };
    },
    computed: {},
    watch: {
        isScrolled() {
            this.setImage();
        }
    },
    created() {
    },
    mounted() {
        this.setImage();
    },
    methods: {
        setImage() {
            if (this.large) {
                if (this.isScrolled) {
                    this.scroll = 'show-image';
                    this.nonScroll = 'hide-image';
                } else {
                    this.scroll = 'hide-image';
                    this.nonScroll = 'show-image';
                }
            }
        },
        url(linkSystem) {
            if (linkSystem) {
                return linkSystem.Url;
            }
            return '';
        }
    }
};
</script>
<style lang="scss" scoped>
.hide-image {
    // opacity: 0;
}

.show-image {
    transition: background-image 1s ease-in-out;
    background-size: contain;
    height: 100%;
}

.logo {
    background-repeat: no-repeat;

}

.logo-container {
    &.large {
        padding: 21.14px 0 20.55px 10px;

        &.scrolled{
            padding: 16.58px 0 16.24px 10px;

        }
    }

    &.small {
        padding: 10.27px 0 6.05px 0;

    }
}

.ee {
    &>div {
        height: 100%;
        width: auto;
    }
}
</style>
